import { ICustomConfig } from "../interface";

export const buildQueryString = (
  params: Record<string, string | number | boolean | null | undefined>
): string => {
  if (!params || typeof params !== "object") {
    return "";
  }

  const validParams = Object.entries(params)
    .filter(([_, value]) => value !== null && value !== undefined)
    .map(([key, value]) => {
      const encodedKey = encodeURIComponent(key);
      const encodedValue = encodeURIComponent(String(value));
      return `${encodedKey}=${encodedValue}`;
    })
    .join("&");

  return validParams ? `?${validParams}` : "";
};

export const getCommonHeaders = (config: ICustomConfig) => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  if (config.merchantId) {
    headers.append("gk-merchant-id", config.merchantId);
  }

  // Add common headers from config
  if (config.commonHeaders) {
    Object.entries(config.commonHeaders).forEach(([key, value]) => {
      headers.append(key, value);
    });
  }

  return headers;
};
